import { ApiPeriodGroup } from '../../../redux/context/actions'
import { fetchDriverData } from '../service/driverDataService'
import { DriverData } from '../types/driverData'
import driverDataQueryKeys from './driverDataQueryKeys'

export const getDriverDataOptions = <TData = DriverData[]>(
  companyId: string,
  budgetingScenarioId?: number | null,
  periodGroups?: ApiPeriodGroup[],
  select?: (data: DriverData[]) => TData,
  dimensions?: string
) => {
  return {
    queryKey: driverDataQueryKeys.list(companyId, budgetingScenarioId, periodGroups),
    queryFn: (context: Parameters<typeof fetchDriverData>[0]) => fetchDriverData(context, dimensions),
    gcTime: 15 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    enabled: !!companyId,
    select
  }
}
